import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  hexToRgb,
  domainFacilitateColor,
  domainDesignColor,
  domainOptimiseColor,
  domainTransformColor,
  domainInnovateColor,
  domainExperienceColor,
  domainCollaborateColor,
  domain1Color,
  domain2Color,
  domain3Color,
  domain4Color,
  domain5Color,
  domain6Color,
  domain7Color
} from "assets/jss/material-kit-pro-react.jsx";

const customLinearProgressStyle = {
  root: {
    height: "2px",
    marginBottom: "20px",
    overflow: "hidden"
  },
  bar: {
    height: "2px"
  },
  primary: {
    backgroundColor: primaryColor[0]
  },
  warning: {
    backgroundColor: warningColor[0]
  },
  danger: {
    backgroundColor: dangerColor[0]
  },
  success: {
    backgroundColor: successColor[0]
  },
  info: {
    backgroundColor: infoColor[0]
  },
  rose: {
    backgroundColor: roseColor[0]
  },
  gray: {
    backgroundColor: grayColor[0]
  },
  design: {
    backgroundColor: domainDesignColor[0]
  },
  facilitate: {
    backgroundColor: domainFacilitateColor[0]
  },
  optimise: {
    backgroundColor: domainOptimiseColor[0]
  },
  assessment: {
    backgroundColor: domainTransformColor[0]
  },
  experience: {
    backgroundColor: domainExperienceColor[0]
  },
  industry: {
    backgroundColor: domainCollaborateColor[0]
  },
  innovation: {
    backgroundColor: domainInnovateColor[0]
  },
  D1: {
    backgroundColor: domain1Color[0]
  },
  D2: {
    backgroundColor: domain2Color[0]
  },
  D3: {
    backgroundColor: domain3Color[0]
  },
  D4: {
    backgroundColor: domain4Color[0]
  },
  D5: {
    backgroundColor: domain5Color[0]
  },
  D6: {
    backgroundColor: domain6Color[0]
  },
  D7: {
    backgroundColor: domain7Color[0]
  },
  primaryBackground: {
    background: "rgba(" + hexToRgb(primaryColor[0]) + ", 0.2)"
  },
  warningBackground: {
    background: "rgba(" + hexToRgb(warningColor[0]) + ", 0.2)"
  },
  dangerBackground: {
    background: "rgba(" + hexToRgb(dangerColor[0]) + ", 0.2)"
  },
  successBackground: {
    background: "rgba(" + hexToRgb(successColor[0]) + ", 0.2)"
  },
  infoBackground: {
    background: "rgba(" + hexToRgb(infoColor[0]) + ", 0.2)"
  },
  roseBackground: {
    background: "rgba(" + hexToRgb(roseColor[0]) + ", 0.2)"
  },
  grayBackground: {
    background: "rgba(" + hexToRgb(grayColor[6]) + ", 0.2)"
  },
  designBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainDesignColor[0]) + ", 0.2)"
  },
  facilitateBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainFacilitateColor[0]) + ", 0.2)"
  },
  optimiseBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainOptimiseColor[0]) + ", 0.2)"
  },
  assessmentBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainTransformColor[0]) + ", 0.2)"
  },
  experienceBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainExperienceColor[0]) + ", 0.2)"
  },
  industryBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainCollaborateColor[0]) + ", 0.2)"
  },
  innovationBackground: {
    backgroundColor: "rgba(" + hexToRgb(domainInnovateColor[0]) + ", 0.2)"
  },
  D1Background: {
    backgroundColor: "rgba(" + hexToRgb(domain1Color[0]) + ", 0.2)"
  },
  D2Background: {
    backgroundColor: "rgba(" + hexToRgb(domain2Color[0]) + ", 0.2)"
  },
  D3Background: {
    backgroundColor: "rgba(" + hexToRgb(domain3Color[0]) + ", 0.2)"
  },
  D4Background: {
    backgroundColor: "rgba(" + hexToRgb(domain4Color[0]) + ", 0.2)"
  },
  D5Background: {
    backgroundColor: "rgba(" + hexToRgb(domain5Color[0]) + ", 0.2)"
  },
  D6Background: {
    backgroundColor: "rgba(" + hexToRgb(domain6Color[0]) + ", 0.2)"
  },
  D7Background: {
    backgroundColor: "rgba(" + hexToRgb(domain7Color[0]) + ", 0.2)"
  }
};

export default customLinearProgressStyle;
